import React, { FC, ReactNode } from 'react'
import { RequiredTag } from '../common/RequiredTag'

interface FieldGroupProps {
  fields: Array<{
    label: string
    children: ReactNode
    error?: string
  }>
  required?: boolean
  description?: string
  className?: string
}

export const FieldGroup: FC<FieldGroupProps> = ({
  fields,
  required = false,
  description,
  className = '',
}) => {
  return (
    <div className={`py-2 ${className}`}>
      <div className="md:flex justify-between gap-4">
        {fields.map((field, index) => (
          <div key={index} className="flex-1 mb-2 md:mb-0">
            <div className="flex justify-start">
              <label className="whitespace-nowrap font-bold pr-4">
                {field.label}
              </label>
              <RequiredTag required={required} />
            </div>
            {field.error && (
              <p className="text-main-red text-sm mt-1">{field.error}</p>
            )}
            <div className="mt-1">{field.children}</div>
          </div>
        ))}
      </div>
      {description && (
        <p className="text-gray-400 text-sm py-2">{description}</p>
      )}
    </div>
  )
}
